import React from 'react';
import { Outlet } from 'react-router-dom';

import { ReactComponent as Logo } from '../assets/img/auth/Correcto-Logo.svg';

import Main from '../components/Main';
import { UserRole } from '../types/auth';
import CompanyBanner from '../components/auth/CompanyBanner';
import EmployeeBanner from '../components/auth/EmployeeBanner';
import { LocaleProvider } from '../contexts/LocaleContext';
import FooterSignIn from '../components/auth/FooterSignIn';

interface Props {
  pageRoleType?: UserRole;
}


const SignInLayout = ({ children, pageRoleType = UserRole.COMPANY_ADMIN }: React.PropsWithChildren<Props>) => {


// useEffect(() => {
//   if (i18n.language !== 'se') {
//     i18n.changeLanguage('se');
//   }
// }, []);
  return (
    <React.Fragment>
     <LocaleProvider>
      <Main>
        <div className="auth-screen">
          <div className="form-sidebar vh-100 d-flex flex-column align-content-center justify-content-between">
            <div className="ds">
              <Logo className="correcto-logo" />
              {children}
              <Outlet />
            </div>
  
            <FooterSignIn/>
          </div>
          {pageRoleType === UserRole.COMPANY_ADMIN && <CompanyBanner />}
          {pageRoleType === UserRole.EMPLOYEE && <EmployeeBanner />}
        </div>
      </Main>
      </LocaleProvider>
    </React.Fragment>
  );
}

export default SignInLayout;
